import { useCallback } from "react";
import { useWebHaptics } from "web-haptics/react";
import { HAPTIC_LIGHT_NAV } from "../hapticPatterns";

type Props = {
  onClose: () => void;
};

export function AboutScreen({ onClose }: Props) {
  const { trigger } = useWebHaptics();
  const tap = useCallback(() => void trigger([...HAPTIC_LIGHT_NAV]), [trigger]);

  const handleClose = useCallback(() => {
    tap();
    onClose();
  }, [tap, onClose]);

  return (
    <div className="app-screen">
      <header className="app-header">
        <button type="button" className="app-back" onClick={handleClose}>
          ← Home
        </button>
        <div className="app-header-brand">
          <h1 className="app-title">About</h1>
        </div>
      </header>
      <div className="app-body about-body">
        <p className="about-lede">Vertical media creator and videographer</p>
        <p className="about-copy">
          I capture the energy of live music through a variety of short-form vertical content.
          <br /><br />
          Experienced in crowdwork, interviews, and DJ shots.
        </p>
      </div>
    </div>
  );
}
